import { adminPaths } from "@app/routing/adminPaths";
import { makeAbsoluteUrl } from "@app/routing/utils";
import { DocumentType } from "@generated/client/graphql";

export function makeDocumentLink<
    AnnotationDoc extends {
        type: DocumentType;
        uniqueUrl: string;
    },
>(annotationDocument: AnnotationDoc | undefined, orgUname?: string) {
    if (!annotationDocument || !orgUname) return "#";

    let documentTypePath: string = adminPaths.custom_documents;
    if (
        annotationDocument.type === DocumentType.Policy ||
        annotationDocument.type === DocumentType.MasterPolicy
    ) {
        documentTypePath = adminPaths.policies;
    }
    if (annotationDocument.type === DocumentType.Procedure) {
        documentTypePath = adminPaths.measures;
    }

    const relativePath = `o/${orgUname}/admin/${documentTypePath}/${annotationDocument.uniqueUrl}`;
    const absolutePath = makeAbsoluteUrl(relativePath);
    return absolutePath;
}

export function makeIndicatorLink(indicatorName: string, orgUname?: string) {
    if (!orgUname) return "#";
    return makeAbsoluteUrl(
        `o/${orgUname}/admin/reporting/overview/?search=${indicatorName}`,
    );
}
